import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod } from "../core/base-api/methods-maker";
export var ChannelsApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(ChannelsApi, _BaseApi);

  var _super = _createSuper(ChannelsApi);

  function ChannelsApi() {
    _classCallCheck(this, ChannelsApi);

    return _super.apply(this, arguments);
  }

  return ChannelsApi;
}(BaseApi);
/**
 * list of channels. paged
 */

ChannelsApi.prototype.list = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.List
});
/**
 * info for channel. VideoCollection-like
 */

ChannelsApi.prototype.show = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.Show
});
/**
 * request player videos for given channel
 */

ChannelsApi.prototype.listVideos = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.ListVideos
});
/**
 * return index of video of given video id in collection. based on order
 */

ChannelsApi.prototype.findVideoIndex = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.FindVideoIndex
});
/**
 * list of editions for channel
 */

ChannelsApi.prototype.listEditions = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.ListEditions
});
/**
 * info for channel edition. VideoCollection-like
 */

ChannelsApi.prototype.showEdition = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.ShowEdition
});
/**
 * request player videos for given channel
 */

ChannelsApi.prototype.listEditionVideos = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.ListEditionVideos
});
/**
 * return index of video of given video id in collection. based on order
 */

ChannelsApi.prototype.findEditionVideoIndex = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.FindEditionVideoIndex
});
/**
 * list of playlists for channel edition
 */

ChannelsApi.prototype.listEditionPlaylists = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.ListEditionPlaylists
});
/**
 * info for channel edition playlist. VideoCollection-like
 */

ChannelsApi.prototype.showEditionPlaylist = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.ShowEditionPlaylist
});
/**
 * request player videos for given channel
 */

ChannelsApi.prototype.listEditionPlaylistVideos = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.ListEditionPlaylistVideos
});
/**
 * return index of video of given video id in collection. based on order
 */

ChannelsApi.prototype.findEditionPlaylistVideoIndex = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.FindEditionPlaylistVideoIndex
});
/**
 * list of featured channels. paged
 */

ChannelsApi.prototype.listFeatured = makeMethod({
  method: 'get',
  path: Request.Channels.Paths.ListFeatured
});